export type FormFieldOptionRow = { value: string; label: string };

/** Human-readable label for a select/radio option (canvas + public runtime). */
export function formFieldOptionDisplayLabel(
	row: Pick<FormFieldOptionRow, "label" | "value">
): string {
	const label = row.label?.trim() ?? "";
	if (label.length > 0) {
		return label;
	}
	return row.value?.trim() ?? "";
}

function normalizeOptionRow(raw: unknown): FormFieldOptionRow | null {
	if (typeof raw === "string") {
		const t = raw.trim();
		if (t.length === 0) {
			return null;
		}
		return { value: t, label: t };
	}
	if (typeof raw !== "object" || raw === null) {
		return null;
	}
	const row = raw as Record<string, unknown>;
	const value =
		(typeof row.value === "string" ? row.value : undefined) ??
		(typeof row.name === "string" ? row.name : undefined) ??
		"";
	const label =
		(typeof row.label === "string" ? row.label : undefined) ??
		(typeof row.text === "string" ? row.text : undefined) ??
		"";
	const v = value.trim();
	const l = label.trim();
	if (v.length === 0 && l.length === 0) {
		return null;
	}
	if (v.length === 0) {
		return { value: l, label: l };
	}
	return { value: v, label: l.length > 0 ? l : v };
}

/** Coerce persisted / HubSpot / legacy JSON into `{ value, label }` rows. */
export function normalizeFormFieldOptionRows(
	raw: unknown
): FormFieldOptionRow[] {
	if (!Array.isArray(raw)) {
		return [];
	}
	const out: FormFieldOptionRow[] = [];
	for (const item of raw) {
		const row = normalizeOptionRow(item);
		if (row) {
			out.push(row);
		}
	}
	return out;
}
